import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";

import { getLibraryContents } from "../../services/portalAluno/library/libraryService";
import type { ApplicationState } from "../../store";

export const portalLibraryQueryKey = (idUsuario?: number) => [
  "portal-aluno",
  "biblioteca",
  idUsuario,
];

const useLibraryContents = (enabled = true) => {
  const auth = useSelector((state: ApplicationState) => state.auth.data);
  const idUsuario = auth?.idUsuario;

  return useQuery({
    enabled: enabled && Boolean(idUsuario),
    queryKey: portalLibraryQueryKey(idUsuario),
    queryFn: () => getLibraryContents(),
  });
};

export default useLibraryContents;
